import { Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { DropdownCaretIcon, FiatIcon } from 'BreetAssets';
import { CURRENCYCONFIG, getSafeObjectField } from 'BreetHelpers';

import type { ModernCurrencyDropdownControlProps } from '../../Dropdown.helpers';

export const ModernCurrencyDropDownControl = ({
	selectedItem,
	buttonRef,
	handleVisibility,
	visible,
	isLabel,
	disabled,
}: ModernCurrencyDropdownControlProps) => {
	const openClass = visible ? ' open' : '';
	const validClass = selectedItem?.currency ? ' valid' : '';
	const labelClass = !isLabel ? ' no-label' : '';

	const buttonClass = `dropdown_content_control modern-dropdown_control${openClass}${validClass}${labelClass}`;

	return (
		<button
			onClick={disabled ? undefined : handleVisibility}
			className={buttonClass}
			ref={buttonRef}
			type='button'
			aria-expanded={visible}
			disabled={disabled}
		>
			{!!selectedItem?.currency && (
				<Typography
					as='span'
					className='dropdown_content_control_flag'
				>
					<FiatIcon
						currencyCode={selectedItem.currency}
						variant='round'
					/>
				</Typography>
			)}

			<div>
				<Typography as='label'>{selectedItem?.currency} Wallet Balance</Typography>
				{!!selectedItem?.walletBalance && (
					<Typography
						as='span'
						className='dropdown_content_control_code color-neutral-50'
					>
						{getSafeObjectField(CURRENCYCONFIG, selectedItem.currency)?.symbol}
						{selectedItem.walletBalance}
					</Typography>
				)}
			</div>

			{!disabled && <DropdownCaretIcon className={classNameMerger('modern-dropdown_control_caret', visible && 'open')} />}
		</button>
	);
};
